/** @jsxImportSource @emotion/react */
import { Box, SxProps, Theme, useTheme } from '@mui/material'
import {
  leftImageStyle,
  rightBoxStyle,
  rightImageStyle,
  section,
  sectionContainer,
} from './Section.styles'

interface SectionProps {
  backgroundColor?: string
  id?: string
  children?: React.ReactNode
  rightSideBox?: React.ReactNode
  rightSideImage?: React.ReactNode
  leftSideImage?: React.ReactNode
  sx?: SxProps<Theme>
}

export const Section = ({
  backgroundColor,
  id,
  children,
  leftSideImage,
  rightSideBox,
  rightSideImage,
  sx,
}: SectionProps) => {
  const theme = useTheme()
  return (
    <Box sx={sx} id={id} css={sectionContainer({ backgroundColor })}>
      <Box css={section(theme)}>
        {leftSideImage && <Box css={leftImageStyle}>{leftSideImage}</Box>}
        <Box sx={{ width: '100%' }}>{children}</Box>
        {rightSideBox && <Box css={rightBoxStyle(theme)}>{rightSideBox}</Box>}
        {rightSideImage && <Box css={rightImageStyle}>{rightSideImage}</Box>}
      </Box>
    </Box>
  )
}
